/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const File = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M15 1L22 9V23H2V1H15ZM14.32 2.5H3.5V21.5H20.5V9.563L14.32 2.5ZM14 4V9.999L19 10V11.5H12.5V4H14Z"
                        fill={color}
                    />
                </svg>
        );
    };
